export const ZhLocale = {
    page: {
        txtTitle: 'UNVOX | 即刻去除人声',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'unvox 标志',
        },
        action: {
            txtBack: '返回',
            txtRetry: '重试',
            txtStartOver: '重新开始',
        },
        job: {
            txtCheckingStatus: '正在检查任务状态',
            txtIdLabel: '任务 ID',
        },
        footer: {
            linkPrivacyPolicy: '隐私政策',
            linkTerms: '条款',
            linkRefunds: '退款',
            linkSupport: '支持',
            txtAllRightsReserved: '保留所有权利。',
            txtBugReportsAndFeatures: '错误报告与功能请求',
        },
        share: {
            title: 'UNVOX | 一键去除歌曲人声',
            text: '轻松将你喜爱的歌曲变成可用于卡拉 OK 的伴奏！',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: '一键人声去除',
            txtHeroSubtitle: '从你的音频或 YouTube 链接即时生成伴奏',
            txtInputTypeLabel: '输入类型',
            txtInputTypeFile: '上传音频文件',
            txtInputTypeYoutube: 'YouTube 链接',
            txtInputFilePick: '选择文件',
            txtInputFileSub: '常见音频格式（{{formats}}），最大 {{size}} MB。',
            txtPreviewAction: '去除人声',
            txtPreviewFailed: '发生未知错误。请稍后再试。',
            txtUploadSelectFile: '尚未选择文件',
            txtYoutubeLabel: 'YouTube URL',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: '粘贴一个公开的 YouTube 链接。',
            txtYoutubeMissing: '请粘贴 YouTube URL。',
            txtYoutubeInvalid: '请输入有效的 YouTube URL。',
            txtYoutubeTooLong: '该视频超过 15 分钟。请选择更短的视频。',
            txtCheckoutUploadFailed: '上传失败。请重试。',
            txtUploadMissing: '上传前请先选择文件。',
            txtFileTypeInvalid: '不支持的文件类型。请上传音频文件（例如 {{formats}}）。',
            txtFileTooLarge: '文件过大。最大大小为 {{size}} MB。',
        },
        previewJob: {
            txtUnavailableTitle: '无法创建预览',
            txtUnavailableBody: '发生未知错误。请稍后再试。',
            txtPreparingTitle: '正在准备预览',
            txtPreparingBody: '这可能需要最多 2 分钟',
        },
        payment: {
            txtUnavailableTitle: '无法创建预览',
            txtUnavailableBody: '发生未知错误。请稍后再试。',
            txtPreparingTitle: '正在准备预览',
            txtCheckoutCancelledBody: '没有产生扣费。你可以随时重试。',
            txtTrackPreviewLabel: '音轨预览',
            txtTrackPreviewHelper: '该预览是你音轨的 15 秒片段，用于效果评估',
            txtEmailLabel: '电子邮箱地址',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: '我们将使用此邮箱发送下载链接。',
            txtCheckoutAction: '仅需 {{price}} 即可去除人声',
            txtCheckoutActionFallback: '去除人声',
            txtCheckoutFailed: '无法开始结账。请重试。',
            txtInvalidEmail: '请输入有效的邮箱地址。',
        },
        processing: {
            txtMissingTitle: '缺少任务 id',
            txtMissingBody: '此页面需要任务 id。请先创建新的预览任务。',
            txtMissingAction: '返回上传页',
            txtStatusFailed: '无法获取任务状态。请重试。',
            txtErrorTitle: '出现问题',
            txtSupportAction: '联系支持',
            txtConfirmingTitle: '正在确认付款',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: '正在检查更新',
            txtWorkingTitle: '正在处理完整音轨',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: '开始另一个',
            txtReadyTitle: '下载已就绪',
            txtReadyBody: '你的伴奏已可下载。',
            txtDownloadAction: '下载',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: '开始另一个',
        },
        invalidJob: {
            txtTitle: '无效任务 id',
            txtBody: '未找到该任务。请重新上传。',
            txtAction: '重新开始',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: '支持',
            txtTitle: '联系支持',
            txtLastUpdatedLabel: '最后更新',
            txtLastUpdatedDate: '2026 年 2 月 9 日',
            txtSectionEmailTitle: '电子邮件',
            txtSectionEmailBodyPrefix: '发送邮件至',
            txtSectionIncludeJobIdTitle: '请提供任务 ID',
            txtSectionIncludeJobIdBody: '请提供任务 ID，方便我们快速定位任务。如果你已付款，请同时提供结账时使用的邮箱。',
            txtSectionBugReportsTitle: '错误报告',
            txtSectionBugReportsBody: '你也可以通过页脚链接提交错误报告和功能请求。',
        },
        bugReportsFeatures: {
            txtEyebrow: '反馈',
            txtTitle: '错误报告与功能请求',
            txtSubtitle: 'UNVOX 还处于早期阶段。如果你发现问题或有想法，请告诉我们。清晰的报告能让修复更快上线。',
            txtWhatToIncludeTitle: '建议包含',
            txtChecklistExpectedVsActual: '你的预期与实际结果',
            txtChecklistSteps: '复现步骤（1、2、3）',
            txtChecklistBrowserOs: '你的浏览器和操作系统',
            txtChecklistJobId: '任务 ID（如果与上传有关）',
            txtTipTitle: '提示',
            txtTipBody: '如果你通过邮件联系我们，可以直接回复已收到的交付邮件并粘贴模板。',
            txtTemplateTitle: '复制粘贴模板',
            txtTemplateBody: '错误报告 / 功能请求\n\n类型: bug | feature\n摘要:\n\n详情:\n- 实际发生了什么:\n- 你期望发生什么:\n- 复现步骤:\n  1.\n- 浏览器/操作系统:\n\n可选:\n- 任务 ID:\n- YouTube URL:\n- 截图/视频:\n',
            txtTemplatePageLabel: '页面',
            txtTemplateUserAgentLabel: 'User agent',
            txtCopyActionIdle: '复制模板',
            txtCopyActionCopied: '已复制',
            txtCopyActionFailed: '复制失败',
            txtCopyHelpFailed: '剪贴板访问被阻止。你仍可手动选择并复制上方文本。',
            txtCopyHelpIdle: '这里不会自动发送任何内容。此页面仅帮助你整理高质量反馈。',
        },
    },
};
